export default {
  lineColor: 'Л',
  lineColorFull: 'Цвет линии',
  fillColor: 'З',
  fillColorFull: 'Цвет заливки',
  alpha: 'П',
  alphaFull: 'Прозрачность',
  lineWidth: 'Ш',
  lineWidthFull: 'Ширина линии',
  arrowLength: 'Ш',
  arrowLengthFull: 'Ширина стрелки',
  eraserWidth: 'Ш',
  eraserWidthFull: 'Ширина ластика',
  textColor: 'Ц',
  textColorFull: 'Цвет текста',
  fontSize: 'Р',
  fontSizeFull: 'Размер шрифта',
  fontStrokeSize: 'Ш',
  fontStrokeSizeFull: 'Ширина штриха',
  fontIsBold: '<b>Ж</b>',
  fontIsBoldFull: 'Жирный',
  fontIsItalic: '<i>К</i>',
  fontIsItalicFull: 'Курсив',
  shadowOn: 'Т',
  shadowOnFull: 'Тень',
  fontStrokeAndShadow: 'О&Т',
  fontStrokeAndShadowFull: 'Обводка и Тень',
  fontName: 'Ш',
  fontNameFull: 'Название шрифта',
  textStrokeColor: 'ЦО',
  textStrokeColorFull: 'Цвет обводки',
  apply: 'Применить',
  cancel: 'Отмена',
  close: 'Закрыть',
  clear: 'Очистить',
  width: 'Ширина',
  height: 'Высота',
  keepRatio: 'Сохранить соотношение ширины/высоты',
  fillPageWith: 'Заполнить страницу текущим цветом фона',
  pixelSize: 'П',
  pixelSizeFull: 'Размер пикселя',
  resizeScale: 'Масштаб',
  resizeResize: 'Изменить размер',
  backgroundColor: 'Цвет фона страницы',
  pixelizePixelSize: 'Пикселизация размера пикселя',
  language: 'Язык',
  wrongPixelSizeValue:
    'Неправильный размер пикселя. Вы можете ввести, например \'20%\', что означает, что средний размер пикселя будет 1/5 от' +
    'стороны выбранной области или \'4\', что означает 4 пикселя',
  tools: {
    crop: 'Обрезать изображение до выделенной области',
    pixelize: 'Сделать пикселизацию выделенной области',
    rect: 'Рисовать прямоугольник',
    ellipse: 'Рисовать эллипс',
    line: 'Рисовать линию',
    arrow: 'Рисовать Стрелку',
    rotate: 'Повернуть лист',
    save: 'Сохрнить изображение',
    load: 'Загрузть изображение',
    text: 'Вставить текст',
    brush: 'Кисть',
    resize: 'Изменить размер или масштаб',
    open: 'Открыть изображение',
    select: 'Выбрать область',
    close: 'Закрыть редактор',
    eraser: 'Ластик',
    settings: 'Настройки',
    undo: 'Отменить',
    redo: 'Повторить',
  },
  pasteOptions: {
    fit: 'Заменить всё',
    extend_down: 'Добавить вниз',
    extend_right: 'Добавить вправо',
    extend_left: 'Добавить влево',
    extend_top: 'Добавить вверх',
    extend: 'Добавить',
    over: 'Вставить',
    how_to_paste: 'Как вставить?',
  },
};
